import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.avif";
// eslint-disable-next-line no-restricted-imports
import { height, width } from "./header_image.avif?as=metadata:height;width";
// eslint-disable-next-line no-restricted-imports
import headerImageSrcset from "./header_image.avif?w=480;960;1920&format=avif&as=srcset";

export const frontmatter: BlogFrontmatter = {
  title: "Stor nyhet: Oscar Reimer blir CTO och medgrundare",
  header: "🚀 Stor nyhet: Oscar Reimer blir CTO och medgrundare",
  date: "2025-09-24",
  description:
    "Varför Oscar ansluter till Controla, hans resa från Debricked och vad det betyder för vår produkt framåt.",
  category: "företag",
  draft: false,
  authorKey: "agnes_onne",
  headerImage,
  headerImageSrcset,
  headerImageDimensions: {
    height,
    width,
  },
};
